/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const UserRoleName = zod.strictObject({
    name: zod.string(),
    id: zod.number(),
});

export type UserRoleName = zod.input<typeof UserRoleName>;
export type UserRoleNameOutput = zod.output<typeof UserRoleName>;
